import React from 'react'
import Link from 'next/link'

const ToolLinks = () => {
  return (
    <div className="mt-48 min-w-[500px] h-fit p flex justify-end items-center grid gap-2 ml-auto">
      <div className="p-10 grid gap-2 mx-auto bg-zinc-100 rounded-xl min-w-[300px] drop-shadow-xl">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Other tools</h2>
        <Link href="/tools/report-generator" className="hover:underline">
          Report generator
        </Link>
        <Link href="/tools/research-paper-generator" className="hover:underline">
          Research paper generator
        </Link>
        <Link href="/tools/literature-review-generator" className="hover:underline">
          Literature review generator
        </Link>
        <Link href="/tools/essay-generator" className="hover:underline">
          Essay generator
        </Link>
        <Link href="/tools/sentence-rewriter" className="hover:underline">
          Sentence rewriter
        </Link>
        <Link href="/tools/pdf-summarizer" className="hover:underline">
          PDF summarizer
        </Link>
        <Link href="/tools/book-summarizer" className="hover:underline">
          Book summarizer
        </Link>
        <Link href="/tools/paragraph-generator" className="hover:underline">
          Paragraph generator
        </Link>
      </div>
    </div>
  )
}

export default ToolLinks
